import React from "react";
import { KINDS } from "../../lib/searchApi";
import { cn } from "../../lib/utils";

export const PLACEHOLDER = {
  all: "Search SKU, branch or supplier…",
  sku: "Search SKU code or name…",
  branch: "Search branch code, name or city…",
  supplier: "Search supplier code or name…",
};

export function ScopeSelect({ value, onChange, testid, className }) {
  return (
    <select data-testid={testid} value={value} onChange={e => onChange(e.target.value)} aria-label="Search in"
            className={cn("bg-transparent text-[10.5px] uppercase tracking-wider font-semibold text-muted hover:text-fg outline-none cursor-pointer pr-1 border-r border-border", className)}>
      {KINDS.map(k => <option key={k.id} value={k.id} className="bg-surface text-fg">{k.label}</option>)}
    </select>
  );
}
